import { NSNotifier } from './NSNotifier';
import { IStorage } from 'namirasoft-core';
import { NSRouterMakerComponent } from './NSRouterMakerComponent';

export class NSRouterMaker
{
    private storage: IStorage;
    private setState: () => void;
    private component: NSRouterMakerComponent;
    constructor(storage: IStorage, setState: () => void, component: NSRouterMakerComponent)
    {
        this.storage = storage;
        this.setState = setState;
        this.component = component;
        this.onRender = this.onRender.bind(this);
    }
    onRender(): React.JSX.Element
    {
        return this.component.onRender({ notifier: new NSNotifier(this.storage, this.setState) });
    }
};